import { useEffect, useState } from 'react';

/**
 * L'envol des prénoms : la liste des élèves en attente de scan, et pour chaque
 * prénom qui vient d'en sortir (carte captée) une demi-seconde avec la classe
 * `proj-name-bye`, le temps de l'animation, avant de disparaître.
 *
 * Sorti tel quel de `WaitingBand` (2026-09-19) pour servir aussi l'écran de
 * scan en grand : une seule logique d'envol, deux tailles.
 *
 * @param {{code_aruco:number, nom:string}[]} nonRepondants
 * @returns {{code_aruco:number, nom:string, bye:boolean}[]}
 */
export const useEnvolPrenoms = (nonRepondants) => {
  const [pills, setPills] = useState(() => nonRepondants.map((p) => ({ ...p, bye: false })));

  useEffect(() => {
    setPills((prev) => {
      const ids = new Set(nonRepondants.map((p) => p.code_aruco));
      const connus = new Set(prev.map((p) => p.code_aruco));
      const gardes = prev.map((p) =>
        ids.has(p.code_aruco) ? (p.bye ? { ...p, bye: false } : p) : (p.bye ? p : { ...p, bye: true }),
      );
      const ajoutes = nonRepondants
        .filter((p) => !connus.has(p.code_aruco))
        .map((p) => ({ ...p, bye: false }));
      return [...gardes, ...ajoutes];
    });
    const t = setTimeout(() => {
      setPills((prev) => prev.filter((p) => !p.bye));
    }, 550);
    return () => clearTimeout(t);
  }, [nonRepondants]);

  return pills;
};

export default useEnvolPrenoms;
